<div class="banner">
  <div class="col-12">
    <h1>Messages</h1>
  </div>
  <div class="mt-1">
    <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
  </div>
  <div class="tabcontent mt-3" style="padding-top: 53px;">
    <div class="relative" *ngIf="systemMessages.length > 0">
      <button class="btn btn-primary" (click)="deleteSelectedMessages($event)">Delete Selected Message(s)</button>
      <ul class="message-indicators">
        <li class="mb-1"><i class="far fa-envelope"></i> <strong>General</strong></li>
        <li class="mb-1"><i class="fa-solid fa-gear"></i> <strong>System</strong></li>
        <li class="mb-1"><i class="far fa-star"></i> <strong>Promotion</strong></li>
      </ul>
    </div>
    <p-table styleClass="p-datatable-striped" [value]="systemMessages" selectionMode="multiple" [(selection)]="selectedMessages" [sortOrder]="-1"
      sortField="createTime" [columns]="tableColumn" [scrollable]="true" scrollHeight="50vh" id="messageTable">
      <ng-template pTemplate="header" let-columns>
        <tr *ngIf="systemMessages.length > 0">
          <th class="small-column-flex-override">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let col of columns" [ngSwitch]="col.field">
            <th *ngSwitchCase="'messageType'" class="medium-column-flex-override" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            <th class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field" *ngSwitchDefault>
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            <th *ngSwitchCase="'createTime'" class="xlarge-column-flex-override" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="small-column-flex-override">
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field" [style.width.%]="col.width">
            <td *ngSwitchCase="'messageType'" class="medium-column-flex-override">
              <div [ngSwitch]="rowData.messageType">
                <span *ngSwitchDefault class="far fa-envelope"></span>
                <span *ngSwitchCase="'System'" class="fa-solid fa-gear"></span>
                <span *ngSwitchCase="'Promotion'" class="far fa-star"></span>
              </div>
            </td>
            <td *ngSwitchCase="'subject'">
              <div class="d-flex flex-column">
                <a href (click)="onSubjectClick($event, rowData)">
                  <strong id="{{rowData.messageId}}" *ngIf="!rowData.readByUser">{{rowData.subject}}</strong>
                  <span id="{{rowData.messageId}}" *ngIf="rowData.readByUser">{{rowData.subject}}</span>
                </a>
                <br>
                <pre *ngIf="rowData.expanded" class="message-text">{{rowData.text}}</pre>
              </div>
            </td>
            <td *ngSwitchCase="'createTime'" class="xlarge-column-flex-override">
              {{ rowData.createTime | date: "M/d/YYYY h:mm a" }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="noBorder">
            <b>There are no messages.</b>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-confirmDialog key='confirmDelete' #deleteMessageModal width="425" [closable]="false">
  <p-footer>
    <button i18n id="scaccept" class="btn btn-primary me-2" (click)="deleteMessageModal.accept()">OK</button>
    <button i18n id="screject" class="btn btn-secondary" (click)="deleteMessageModal.reject()">Cancel</button>
  </p-footer>
</p-confirmDialog>